import AitiCoreValidatorEmail from './validators/email';
import AitiCoreValidatorPhoneNumber from './validators/phoneNumber';
import AitiCoreValidatorPostCode from './validators/postCode';

export default class AitiCoreValidators {

    private readonly _emailValidator: AitiCoreValidatorEmail;
    private readonly _phoneNumberValidator: AitiCoreValidatorPhoneNumber;
    private readonly _postCodeValidator: AitiCoreValidatorPostCode;

    constructor() {
        this._emailValidator = new AitiCoreValidatorEmail();
        this._phoneNumberValidator = new AitiCoreValidatorPhoneNumber();
        this._postCodeValidator = new AitiCoreValidatorPostCode();
    }

    getEmailValidator() {
        return this._emailValidator;
    }

    getPhoneNumberValidator() {
        return this._phoneNumberValidator;
    }

    getPostCodeValidator() {
        return this._postCodeValidator;
    }
}
